export default function ImportIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4748_15359'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4748_15359)'>
        <path
          d='M9.98698 17.9033C8.89295 17.9033 7.86441 17.6953 6.90135 17.2792C5.93816 16.8631 5.10024 16.2987 4.3876 15.586C3.67497 14.8734 3.11059 14.0355 2.69448 13.0723C2.27837 12.1092 2.07031 11.0807 2.07031 9.98667C2.07031 8.23347 2.58899 6.65896 3.62635 5.26313C4.66385 3.86729 6.02017 2.91458 7.69531 2.405V3.74792C6.37795 4.22972 5.31948 5.03903 4.5199 6.17583C3.72017 7.3125 3.32031 8.58278 3.32031 9.98667C3.32031 11.8478 3.96615 13.4242 5.25781 14.7158C6.54948 16.0075 8.12587 16.6533 9.98698 16.6533C11.8481 16.6533 13.4245 16.0075 14.7161 14.7158C16.0078 13.4242 16.6536 11.8478 16.6536 9.98667C16.6536 8.58278 16.2538 7.3125 15.4541 6.17583C14.6545 5.03903 13.596 4.22972 12.2786 3.74792V2.405C13.9538 2.91458 15.3101 3.86729 16.3476 5.26313C17.385 6.65896 17.9036 8.23347 17.9036 9.98667C17.9036 11.0807 17.6956 12.1092 17.2795 13.0723C16.8634 14.0355 16.299 14.8734 15.5864 15.586C14.8737 16.2987 14.0358 16.8631 13.0726 17.2792C12.1095 17.6953 11.081 17.9033 9.98698 17.9033ZM9.98698 13.0235L6.10885 9.14542L6.98698 8.26708L9.36198 10.6294V2.07812H10.612V10.6294L12.987 8.26708L13.8651 9.14542L9.98698 13.0235Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
